import { useEffect, useState } from "react";
import VideoCall from "./VideoCall";
import { firebaseConfig } from "./settings";
import { createClient, createMicrophoneAndCameraTracks, registerExtensions } from "agora-rtc-react";
import { useParams } from "react-router-dom";
import VirtualBackgroundExtension from "agora-extension-virtual-background";

// FIREBASE
import firebase from "firebase/app";

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

function App() {
  const [inCall, setInCall] = useState(true);

  const { appID, channelName, uid, consultaId, token, tipo, userName } = useParams();

  const tokenDecode = window.atob(token);

  console.log(appID, channelName, uid, consultaId, tipo, userName);

  const [paginaError, setPaginaError] = useState(!appID && !channelName && !uid && !consultaId && !token && !tipo && !userName);

  const config = { mode: "rtc", codec: "vp8" };
  const useClient = tokenDecode !== "" ? createClient(config) : null;
  const useTracks = tokenDecode !== "" ? createMicrophoneAndCameraTracks() : null;

  // Create a VirtualBackgroundExtension instance
  const extension = new VirtualBackgroundExtension();
  // Register the extension
  registerExtensions([extension]);

  useEffect(() => {    
    window.onbeforeunload = confirmExit;
    function confirmExit() {
      return "show warning";
    }    
  }, []);

  return (
    <div className="App" style={{ height: "100%" }}>
      {!paginaError ? (
        inCall ? (
          <VideoCall
            extension={extension}
            useClient={useClient}
            useTracks={useTracks}
            setInCall={setInCall}
            inCall={inCall}
            token={tokenDecode}
            uid={uid}
            appID={appID}
            channelName={channelName}
            consultaId={consultaId}
            userName={userName}
            setPaginaError={setPaginaError}
            tipo={tipo}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <div>Llamada Terminada</div>
          </div>
        )
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>Error al cargar la video llamada</div>
        </div>
      )}
    </div>
  );
}

export default App;
